module.exports = __webpack_public_path__ + "img/icon-file.0145dd1a.svg";